import { useCallback, useState } from 'react';

export const useAssetVisibility = (initial = false) => {
  const [isAssetVisible, setIsAssetVisible] = useState(initial);

  const toggleAssetVisibility = useCallback(() => {
    setIsAssetVisible((prev) => !prev);
  }, []);

  return {
    isAssetVisible,
    toggleAssetVisibility,
  };
};
